export default "__VITE_ASSET__CFdSELjN__"